import { ALL_USERS } from '../actions/constant'

const allUsers =(state = [], action)=> {
    switch (action.type) {

        case ALL_USERS:
            return action.payload
        
        default:
            return state
    }
}

export default allUsers